import React from "react";
import { HeaderDrawerMain } from "components";
import { ChangePassword } from "fragments";

export const ChangePasswordDrawerContent = ({ closeDrawer, anchor }) => {
  return (
    <div>
      <HeaderDrawerMain title="Change Password" closeModal={closeDrawer} />
      <div style={{ padding: 16 }}>
        <ChangePassword handleCancel={() => closeDrawer(anchor)} />
      </div>
    </div>
  );
};
